<template>
  <div class="company-search-input section-header-left user-requests-search">
    <input :placeholder="placeholder"
           :value="value"
           autocomplete="off"
           type="search"
           @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: "CompanySearchInput",
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.user-requests-search {
  display: flex;
  width: 100%;
  flex: 1 1 auto;
  min-width: 0;
  align-items: center;
}

.user-requests-search input {
  width: 100%;
  height: 48px;
  min-height: 48px;
  margin: 0;
  padding: 12px 16px;
  box-sizing: border-box;
  border: 1px solid #cfd5df;
  border-radius: 10px;
  background: var(--request-surface);
  color: var(--request-text);
  font-size: 16px;
  line-height: 1.4;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.user-requests-search input::placeholder {
  color: #858da0;
  opacity: 1;
}

.user-requests-search input:focus {
  border-color: var(--request-primary);
  box-shadow: 0 0 0 3px rgba(62, 65, 109, 0.16);
}

@media (prefers-reduced-motion: reduce) {
  .user-requests-search input {
    transition: none;
  }
}
</style>
